import { environment } from './environment';

export const Endpoints = {
  strappi: {
    base: `${environment.strappiUrl}`,
    homepage: `${environment.strappiUrl}/homepage`,
    homepageB: `${environment.strappiUrl}/homepage-b`,
    faqs: `${environment.strappiUrl}/fa-qs`,
    footer: `${environment.strappiUrl}/footer`,
    footerB: `${environment.strappiUrl}/footer-b`,
    staticPage: `${environment.strappiUrl}/static-pages`,
    boletin: `${environment.strappiUrl}/comunicados`,
    planPage: `${environment.strappiUrl}/planes`,
    imagesSearcher: `${environment.strappiUrl}/imagenes-buscador`,
    imagesGeneral: `${environment.strappiUrl}/imagenes-general`,
    disclaimers: `${environment.strappiUrl}/disclaimers`,
    pdf: `${environment.strappiUrl}/documentos-cotizador`,
  },
  catalogs: {
    base: `${environment.catalogsUrl}`,
    specsById: `${environment.catalogsUrl}/specs-car`,
    imgesById: `${environment.catalogsUrl}/images-car`,
    catalog:  `${environment.catalog}`,
  },
  catalogsV2: {
    base: `${environment.catalogsUrlV2}`,
    specsById: `${environment.catalogsUrlV2}/specs-car`,
    imgesById: `${environment.catalogsUrlV2}/images-car`,
  },
  catalogsV3: {
    base: `${environment.catalogsUrlV3}`,
    specsById: `${environment.catalogsUrlV3}/specs-car`,
    imgesById: `${environment.catalogsUrlV3}/images-car`,
  },
  cotizador: {
    base: `${environment.cotizadorUrl}`,
  },
  cotizadorV2: {
    base: `${environment.cotizadorUrlV2}`,
  },
  cotizadorV3: {
    base: `${environment.cotizadorUrlV3}`,
  },
  buro: {
    base: `${environment.buroUrl}`,
    documentManagmentUrl: `${environment.documentManagmentUrl}`,
    documentManagmentUrlPublic: `${environment.documentManagmentUrlPublic}`,
    documentManagmentUrlPublicv3: `${environment.documentManagmentUrlPublicv3}`,
    otp: `${environment.otp}`,
  },
  risk: {
    base: `${environment.riskUrl}`,
  },
  sse: {
    base: `${environment.sse.url}`,
  },
  solicitud: {
    base: `${environment.solicitudUrl}`,
    validity: `${environment.solicitudValidityUrl}`,
  },
  credit: {
    base: `${environment.creditUrl}`,
    autocompare: `${environment.creditUrl}/autocompare`,
  },
  creditV2: {
    base: `${environment.creditUrlV2}`,
    autocompare: `${environment.creditUrlV2}/autocompare`,
  },
  creditV3: {
    base: `${environment.creditUrlV3}`
  },
  clientes: {
    base: `${environment.clientesUrl}`,
  },
  carManager: {
    base: `${environment.carManagerUrl}`,
  },
  carManagerV2: {
    base: `${environment.carManagerUrlV2}`,
  },
  bitly: {
    shortenLink: `${environment.bitly.url}/shorten`,
  },
  payment: {
    base: `${environment.paymentUrl}`
  }
};

export const TokenExcludedEndpoints = ['login'];